import React, { useEffect, useRef, useState } from 'react'
import { X } from 'react-bootstrap-icons'
import FilterItemsList from './FilterItemsList'
import { isNoItemsAvailable } from '../../domain/filterOptions/useCases/isNoItemsAvailable'
import { isNoSearchResults } from '../../domain/filterOptions/useCases/isNoSearchResults'
import {
  SearchInput,
  NoItemsAvailableMessage,
  NoSearchResultsMessage
} from './FilterTopbar'
import SearchAutocompleteLoading from '../Search/SearchAutocompleteLoading'

const FilterBottomSheet = ({
  setPopperElement,
  popperAttributes,
  label,
  toggleProps,
  selectedItems,
  refine,
  searchable,
  searchQuery,
  setSearchQuery,
  searchForItems,
  items,
  getItemProps,
  onSelectionChange,
  multiSelect,
  formatCount,
  topBarRef,
  clearFilters,
  taxonomy,
  setSearchState
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const noItemsAvailable = isNoItemsAvailable(searchable, searchQuery, items)
  const noSearchResults = isNoSearchResults(items, searchQuery)
  const thereAreItemsAvailableAndNoSearchResults =
    !noItemsAvailable && noSearchResults
  const thereAreItemsAvailableAndSearchResults =
    !noItemsAvailable && !noSearchResults

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setIsLoading(false)
    }, 500)
    return () => clearTimeout(delayDebounceFn)
  }, [items])

  const closeBottomSheet = (e) => {
    toggleProps.onClick(e)
  }

  return (
    <div
      className="fixed left-0 top-0 z-40 h-screen w-screen bg-gray-1000/50"
      ref={setPopperElement}
      onClick={closeBottomSheet}
      {...popperAttributes.popper}
    >
      <div
        className="pointer-events-auto absolute bottom-0 z-50 flex h-[90vh] w-full flex-col rounded-t-3xl bg-white pt-4 shadow-md"
        onClick={(e) => {
          e.stopPropagation()
        }}
      >
        <div className="relative flex h-[42px] items-center justify-between px-4">
          <div className="absolute inset-x-0 flex h-full items-center justify-center text-center text-lg font-medium">
            {label}
          </div>
          <div className="flex h-[42px] items-center">
            <button
              onClick={closeBottomSheet}
              className="z-50 flex items-center justify-center"
            >
              <X className="size-7" />
            </button>
          </div>
          {selectedItems.length > 0 && (
            <ClearButton
              clearFilters={clearFilters}
              refine={refine}
              closeBottomSheet={closeBottomSheet}
              taxonomy={taxonomy}
              onSelectionChange={onSelectionChange}
            />
          )}
        </div>
        <div className="border-b border-gray-300 px-4 pb-4 ">
          {searchable && (
            <div className="pt-4">
              <SearchInput
                label={label}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                searchForItems={searchForItems}
                setIsLoading={setIsLoading}
              />
            </div>
          )}
        </div>
        {isLoading ? (
          <SearchAutocompleteLoading className={'m-auto'} />
        ) : (
          <>
            {noItemsAvailable && <NoItemsAvailableMessage label={label} />}
            {thereAreItemsAvailableAndNoSearchResults && (
              <NoSearchResultsMessage
                searchQuery={searchQuery}
                label={label}
              />
            )}
            {thereAreItemsAvailableAndSearchResults && (
              <FilterItemsList
                taxonomy={taxonomy}
                items={items}
                searchQuery={searchQuery}
                selectedItems={selectedItems}
                getItemProps={getItemProps}
                onSelectionChange={onSelectionChange}
                refine={refine}
                toggleProps={toggleProps}
                multiSelect={multiSelect}
                formatCount={formatCount}
                topBarRef={topBarRef}
                hideClearButton={true}
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}

const ClearButton = ({
  clearFilters,
  refine,
  closeBottomSheet,
  onSelectionChange: customeRefine,
  taxonomy
}) => {
  const onClearButtonClick = (e) => {
    if (customeRefine) {
      clearFilters(taxonomy, customeRefine)
      closeBottomSheet(e)
    } else {
      clearFilters(refine)
      closeBottomSheet(e)
    }
  }

  return (
    <button
      className="z-50 h-[42px] rounded-lg py-2 text-primary-500"
      onClick={(e) => onClearButtonClick(e)}
    >
      Clear
    </button>
  )
}

export default FilterBottomSheet
